<script>
import {RouterLink} from "vue-router";
import {RouterView} from "vue-router";
import {mapGetters} from "vuex";
import axios from "axios";
import EffContractNotificationSnackbar from "./components/EffContractNotificationSnackbar.vue";
export default {
  name: "Layout",

  components: {
    EffContractNotificationSnackbar,
    RouterLink,
    RouterView,
  },

  data() {
    return {
      dialogOrder: true,
      loadingReport: false,
    }
  },

  computed: {
    ...mapGetters({
      isAdmin: "effective_contract/isAdmin",
      isUMUManager: "effective_contract/isUMUManager",
    }),

    isPageUMU() {
      return this.$route.name === "effective-contracts-umu-page"
    },

  },

  methods: {
    async downloadExcel() {
      try {
        this.loadingReport = true;
        const response = await axios.get('/excel_contract_create', {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', `Эффективный контракт ${new Date().getFullYear()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("There was an error downloading the file:", error);
      }
      finally {
        this.loadingReport = false;
      }
    }
  }
}
</script>

<template>
  <v-card
    elevation="0"
    min-height="80vh"
  >
    <v-toolbar
      color="teal darken-3"
      height="60px"
      elevation="0"
      dark
    >
      <template v-if="isAdmin || isUMUManager">
        <v-btn text @click="isPageUMU ? $router.push('/effective_contracts/app') : $router.push('/effective_contracts/app/umu')">
          {{isPageUMU ? "Раздел ЭК" : "Раздел УМУ"}}
        </v-btn>
        <v-divider vertical class="mx-2"/>
        <v-btn
          text
          @click="downloadExcel"
          :loading="loadingReport"
        >
          Скачать отчет
        </v-btn>
        <v-divider vertical class="mx-2"/>
      </template>

    </v-toolbar>

    <v-container fluid>
      <router-view/>
      <eff-contract-notification-snackbar/>
    </v-container>
  </v-card>
</template>

<style scoped>

</style>